var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VISA_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1224 570.6",
    style: {
      enableBackground: "new 0 0 1224 570.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Arched_x0020_Green{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}\n\t.st0{fill:#1334CB;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 216,
    y1: 702,
    x2: 216.7071,
    y2: 701.2929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33992A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#141E0F"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.7,7L304.5,389.3H199.9L121.1,84.2c-4.8-18.7-8.9-25.6-23.5-33.6C73.8,37.7,34.5,25.6,0,18.1L2.3,7h168.3 c21.4,0,40.7,14.3,45.6,39l41.7,221.2L360.8,7H464.7z M874.4,264.5c0.4-100.9-139.5-106.5-138.6-151.6c0.3-13.7,13.4-28.3,42-32 c14.2-1.8,53.2-3.3,97.5,17.1l17.3-81.1C868.8,8.3,838.2,0,800.1,0C702.3,0,633.5,51.9,633,126.4c-0.6,55.1,49.1,85.7,86.6,104.1 c38.5,18.7,51.5,30.8,51.3,47.5c-0.3,25.7-30.8,37-59.2,37.4c-49.7,0.8-78.6-13.4-101.6-24.2l-18,83.8 c23.1,10.6,65.8,19.8,110,20.3C806.1,395.3,874.1,343.9,874.4,264.5 M1132.6,389.3h91.4L1144.1,7h-84.4c-19,0-35,11-42.1,28 L869.2,389.3h103.9l20.6-57.1h126.9L1132.6,389.3z M1022.1,253.8l52.1-143.6l29.9,143.6H1022.1z M606.1,7l-81.8,382.3h-98.9 L507.2,7H606.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M665.9,568.7V465.4h64.6v11h-51.4v33H720v10.9h-40.9v37.4h51.4v11H665.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M763.3,461.3v107.4h-12.1V461.3H763.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M821,560.8c6.9,0,12.5-0.8,16.8-2.5c4.3-1.7,8.2-3.9,11.6-6.7h0.3l-1.1,11c-2.3,1.9-5.8,3.7-10.6,5.4 c-4.8,1.7-10.8,2.6-18,2.6c-7.8,0-14.6-1.7-20.5-5.2c-5.8-3.4-10.4-8.2-13.7-14.3c-3.3-6.1-4.9-13-4.9-20.8 c0-7.8,1.6-14.7,4.8-20.8c3.2-6.1,7.6-10.9,13.2-14.3c5.6-3.5,11.8-5.2,18.8-5.2c8.1,0,14.6,1.4,19.7,4.3c5,2.9,8.7,6.8,11,12 s3.5,11.1,3.5,17.9c0,0.9,0,2-0.1,3.3c-0.1,1.3-0.2,2.4-0.4,3.4h-58.1c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3 c0.2,9.2,2.7,16.4,7.6,21.6C805.9,558.2,812.5,560.8,821,560.8z M818,499.2c-6.8,0-12.3,2.1-16.5,6.3c-4.2,4.2-6.7,10-7.6,17.4 h46.4v-1.4c0-4.5-0.7-8.5-2-11.8c-1.4-3.3-3.7-5.9-6.9-7.8C828.1,500.2,823.7,499.2,818,499.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M864.7,530.4c0-7.8,1.6-14.7,4.8-20.8c3.2-6.1,7.7-10.9,13.5-14.3c5.8-3.5,12.6-5.2,20.4-5.2 c6.8,0,12.2,0.8,16.3,2.3c4,1.5,7,3.2,8.9,4.9l1.2,12.8h-0.3c-3.4-3.2-7.1-5.6-11.1-7.3c-4-1.7-8.8-2.6-14.3-2.6 c-5.3,0-9.9,1.2-13.9,3.6c-4,2.4-7.2,5.9-9.5,10.4c-2.3,4.5-3.5,10-3.5,16.3c0,9.5,2.6,16.9,7.7,22.2c5.1,5.3,11.8,7.9,19.9,7.9 c4.3,0,8-0.4,11-1.2c3-0.8,5.6-1.9,8-3.3c2.3-1.4,4.6-3,6.9-4.8h0.4l-1.2,11c-2.2,2.1-5.5,4-9.9,5.8c-4.4,1.8-9.9,2.7-16.5,2.7 c-7.8,0-14.6-1.7-20.4-5.2c-5.8-3.4-10.3-8.2-13.5-14.3C866.3,545.1,864.7,538.2,864.7,530.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M964.7,548.1c0,4.9,1,8.2,3.1,9.9c2.1,1.7,4.8,2.5,8.2,2.5c3.1,0,5.8-0.3,8-0.8c2.3-0.5,4.1-1.2,5.6-1.9h0.4 l-1.1,10.2c-1.4,0.7-3.4,1.4-6.1,1.9c-2.7,0.5-5.5,0.8-8.3,0.8c-6.8,0-12.2-1.6-16-4.8c-3.9-3.2-5.8-8.5-5.8-15.8v-48h-14.1l1.6-8 l12.5-1.8v-16.5l12.1-1.8v18h23.5l-1.5,10.1h-22V548.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1034.9,502.5c-6,0-10.7,1.9-14,5.6c-3.4,3.8-5,9.5-5,17.1v43.5h-12.1v-76.8h11.6v16h0.7 c1.7-6.7,4.7-11.4,8.8-14c4.2-2.6,8.7-3.9,13.6-3.9c1.3,0,2.5,0.1,3.7,0.2c1.2,0.1,2.1,0.3,2.7,0.5l-1.5,13.2h-0.4 c-0.7-0.3-1.8-0.6-3.3-0.9C1038.2,502.7,1036.6,502.5,1034.9,502.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1090.6,490c7.5,0,14.2,1.7,19.9,5.2c5.8,3.5,10.3,8.3,13.5,14.3c3.3,6.1,4.9,13,4.9,20.8 c0,7.8-1.6,14.7-4.9,20.8c-3.3,6.1-7.8,10.8-13.5,14.3c-5.8,3.4-12.4,5.2-19.9,5.2c-7.4,0-14.1-1.7-19.9-5.2 c-5.8-3.4-10.3-8.2-13.6-14.3c-3.3-6.1-4.9-13-4.9-20.8c0-7.8,1.6-14.7,4.9-20.8c3.3-6.1,7.8-10.9,13.6-14.3 C1076.6,491.7,1083.2,490,1090.6,490z M1090.6,560.6c8.5,0,14.9-2.7,19.2-8.1c4.3-5.4,6.5-12.8,6.5-22.1c0-9.4-2.2-16.8-6.5-22.2 c-4.3-5.4-10.7-8.1-19.2-8.1c-8.5,0-15,2.7-19.3,8.1c-4.3,5.4-6.5,12.8-6.5,22.2c0,9.3,2.2,16.7,6.5,22.1 C1075.7,557.9,1082.1,560.6,1090.6,560.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1186.4,490c8.3,0,14.9,2.1,19.6,6.4c4.7,4.3,7.1,10.9,7.1,20v52.4h-12v-49c0-6.4-1.4-11.3-4.2-14.5 c-2.8-3.2-7.8-4.8-15-4.8c-4.3,0-8.1,0.9-11.6,2.6s-6.3,4.2-8.3,7.3c-2,3.2-3.1,6.9-3.1,11.3v47.1h-12.1v-76.8h11.6v16.3h0.7 c1.4-4.4,3.6-7.9,6.6-10.5c2.9-2.7,6.3-4.6,9.9-5.8C1179.2,490.6,1182.8,490,1186.4,490z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectron);
export default __webpack_public_path__ + "static/media/electron.073d65c5d6bff02c317496fbe4256487.svg";
export { ForwardRef as ReactComponent };